// Search zod DTOs (S7) — BUILD_SPEC.md §10 ("Fuzzy search via pg_trgm on
// products/suppliers/customers (`GET /search?q=`)"). Owned by G19 (plan.md) — this is
// the ONLY core file this goal fills for the search module; the barrel
// (schemas/index.ts) already re-exports it (S0).
import { z } from 'zod';
export const searchQuerySchema = z.object({
    q: z.string().min(1, 'q is required'),
    limit: z.coerce.number().int().positive().max(50).default(10),
});
export const SEARCH_ENTITY_KINDS = ['PRODUCT', 'SUPPLIER', 'CUSTOMER'];
export const searchResultSchema = z.object({
    kind: z.enum(SEARCH_ENTITY_KINDS),
    id: z.string(),
    code: z.string(),
    name: z.string(),
    score: z.number(),
});
export const searchResponseSchema = z.object({
    results: z.array(searchResultSchema),
});
//# sourceMappingURL=search.js.map